import { fetchWellnessPrograms } from '../../ducks/strapi.duck';

// Initial state
const initialState = {};

// Reducer
const WellnessProgramPageReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    default:
      return state;
  }
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const response = await dispatch(
    fetchWellnessPrograms({ defaultLocale: config?.localization?.locale || 'en' })
  );
  return response;
};

export default WellnessProgramPageReducer;
